'use strict';

const debounce = require('lodash/debounce');

/**
 * init comparison images
 */
const initComparison = function () {
    /* find all elements with an "overlay" class: */
    let x = document.getElementsByClassName('image-comparison-overlay');

    /**
     * init comparison images
     *  @param {*} img - image element
     */
    function compareImages(img) {
        /* create slider: */
        const slider = document.createElement('div');
        const arrowLeft = document.createElement('span');
        const arrowRight = document.createElement('span');
        arrowLeft.setAttribute('class', 'image-comparison-slider-left');
        arrowRight.setAttribute('class', 'image-comparison-slider-right');
        slider.append(arrowLeft);
        slider.append(arrowRight);
        slider.setAttribute('class', 'image-comparison-slider');

        /* get the width and height of the img element */
        const w = img.offsetWidth;
        const h = img.offsetHeight;

        /* set the width of the img element to 50%: */
        img.style.width = w / 2 + 'px';
        /* insert slider */
        img.parentElement.insertBefore(slider, img);
        /* position the slider in the middle: */
        slider.style.top = h / 2 - slider.offsetHeight / 2 + 'px';
        slider.style.left = w / 2 - slider.offsetWidth / 2 + 'px';

        let clicked = 0;

        /**
         * init slide
         * @param {*} pos - x element
         */
        function slide(pos) {
            /* resize the image: */
            img.style.width = pos + 'px';
            /* position the slider: */
            slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + 'px';
        }

        /**
         * init slide finish
         */
        function slideFinish() {
            /* the slider is no longer clicked: */
            clicked = 0;
        }

        /**
         * init get cursor position
         * @param {*} e - event element
         * @return {*} pos - cursor position
         */
        function getCursorPos(e) {
            let a = 0;
            let pos = 0;
            let ev = e.changedTouches ? e.changedTouches[0] : e; // eslint-disable-line no-param-reassign
            /* get the x positions of the image: */
            a = img.getBoundingClientRect();
            /* calculate the cursor's x coordinate, relative to the image: */
            pos = ev.pageX - a.left;
            /* consider any page scrolling: */
            pos -= window.pageXOffset;
            return pos;
        }

        /**
         * init slide move
         * @param {*} e - event element
         * @return {*} e - slide function
         */
        function slideMove(e) {
            let pos = 0;
            /* if the slider is no longer clicked, exit this function: */
            if (clicked === 0) return false;
            /* get the cursor's x position: */
            pos = getCursorPos(e);
            /* prevent the slider from being positioned outside the image: */
            if (pos < 0) pos = 0;
            if (pos > w) pos = w;
            /* execute a function that will resize the overlay image according to the cursor: */
            return slide(pos);
        }

        /**
         * init comparison images
         *  @param {*} e - event element
         */
        function slideReady(e) {
            /* prevent any other actions that may occur when moving over the image: */
            e.preventDefault();
            /* the slider is now clicked and ready to move: */
            clicked = 1;
            /* execute a function when the slider is moved: */
            window.addEventListener('mousemove', debounce(slideMove, 10));
            window.addEventListener('touchmove', debounce(slideMove, 10));
        }

        /* execute a function when the mouse button is pressed: */
        slider.addEventListener('mousedown', slideReady);
        /* and another function when the mouse button is released: */
        window.addEventListener('mouseup', slideFinish);
        /* or touched (for touch screens: */
        slider.addEventListener('touchstart', slideReady);
        /* and released (for touch screens: */
        window.addEventListener('touchend', slideFinish);
    }

    for (let i = 0; i < x.length; i++) {
        /* once for each "overlay" element:
        pass the "overlay" element as a parameter when executing the compareImages function: */
        compareImages(x[i]);
    }
};

$(document).ready(function () {
    initComparison();
});
